import * as React from 'react';
import svgSrc from 'assets/iconiq.svg';

export const Iconiq = props => (
  <figure {...props}>
    <img src={svgSrc} alt="Top 50" />
  </figure>
);
